import React, { useMemo, useState } from 'react';
import dayjs from 'dayjs';
import DataTable from '../../../../components/LynDataTable/DataTable';
import { Button, Form, Tooltip } from 'antd';
import Notification01Icon from 'assets/icons/notification01Icon';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import { useLocation } from 'react-router-dom';
import LeaseRecordViewModal from './CustomComponents/LeaseRecordViewModal';
import { Box } from '@mui/material';
import ConfirmModal from 'components/modal/ConfirmModal';
import { formatNumber, utcConverter } from './CustomComponents/LeaseUtils/helper';

// CSS to override the default DataTable behavior
const styles = `
  .active .MuiTableCell-root:first-of-type {
    background-color: inherit !important;
  }
`;

const LeaseTable = ({ leaseControlData = [], screen = 'CREATE', queryV3Loader }) => {
	// console.log(leaseControlData,"leaseControlData123");
	const form = Form.useFormInstance();
	const { state } = useLocation();
	const retirementId = form.getFieldValue('retirementId');
	const [isActionColumnShowAllow, setIsActionColumnShowAllow] = useState(false);

	const [getJournalEntryData, { data: journalEntryData, isLoading: isJournalEntryDataLoading }] = useSendControlDataMutation();
	const [getActionRequiredData] = useSendControlDataMutation();
	const [showJournalEntryModal, setShowJournalEntryModal] = useState(false);

	const [rowId, setRowId] = useState(null);
	const [actionRequiredConfirmModal, setActionRequiredConfirmModal] = useState(false);
	const [tableUpperLeftExtraInfo, setTableUpperLeftExtraInfo] = useState({});

	// Inject the style override to fix the color issue
	React.useEffect(() => {
		const styleElement = document.createElement('style');
		styleElement.innerHTML = styles;
		document.head.appendChild(styleElement);

		return () => {
			document.head.removeChild(styleElement);
		};
	}, []);

	const handleEyeButton = async (row) => {
		const index = row.id;

		setTableUpperLeftExtraInfo(
			screen?.toLowerCase() === 'create'
				? {
						// retirementTitle: form.getFieldValue('retirementTitle'),
						retirementPeriod: index + 1,
					}
				: {
						retirementId,
						// retirementTitle: form.getFieldValue('retirementTitle'),
						retirementPeriod: index + 1,
					}
		);
		let calculateData = {};
		let identityData = {};
		const formData = form.getFieldsValue();

		if (screen?.toLowerCase() === 'create') {
			calculateData = {
				// advanceAmount: 0, // Default value for table calculations
				retirementTerm: formData?.retirementTerm,
				discountRate: formData?.initialDiscountRate,
				// Keep these for API - derived from retirementStartDate
				startYear: String(formData?.changes[0]?.inputChangeEffectiveDate?.year()),
				escalation: 0, // Default value for table calculations
				startMonth: String(formData?.changes[0]?.inputChangeEffectiveDate?.month() + 1),
				// paymentFrequency: 'Monthly', // Default value for table calculations
				// paymentTime: 'Start', // Default value for table calculations
				// advanceDuration: 0, // Default value for table calculations
				startDay: String(formData?.changes[0]?.inputChangeEffectiveDate?.date()),
				// upfrontLeasePayment: 0, // Default value for table calculations
				// initialDirectCost: 0, // Default value for table calculations
				// securityDeposit: 0, // Default value for table calculations
				// endOfFinancialYear: formData?.retirementStartDate, // Default value for table calculations
				// advanceAmounts: [], // Default value for table calculations
				// grossRents: [], // Default value for table calculations
				retirementCost: formData?.retirementCost,
				changes: [],
			};
			identityData = {
				retirementStartDate: utcConverter(formData?.retirementStartDate),
				// retirementTitle: formData?.retirementTitle,
				// lessorName: formData?.lessorName,
				retirementTerm: formData?.retirementTerm,
				// leaseEndDate: utcConverter(formData?.leaseEndDate),
				// paymentModality: formData?.paymentModality,
				// retirementType: formData?.retirementType,
				initialDiscountRate: formData?.initialDiscountRate,
				// grossRentList: formData?.grossRentList,
				// paymentFrequency: formData?.paymentFrequency,
				// advanceAmountList: formData?.advanceAmountList,
				// advanceAmount: formData?.advanceAmount,
				// advanceAmounts: formData?.advanceAmounts,
				// upfrontLeasePayment: formData?.upfrontLeasePayment,
				// initialDirectCost: formData?.initialDirectCost,
				// securityDeposit: formData?.securityDeposit,
				// grossRents: formData?.grossRents,
				retirementCost: formData?.retirementCost,
				// Keep these for API - derived from retirementStartDate
				startYear: String(formData?.changes[0]?.inputChangeEffectiveDate?.year()),
				startMonth: String(formData?.changes[0]?.inputChangeEffectiveDate?.month() + 1),
				startDay: String(formData?.changes[0]?.inputChangeEffectiveDate?.date()),
				inputChangeMonth: '1', // Default value for API
				changes: formData?.changes?.map((item) => {
					return {
						...item,
						// inputChangeAdvance: item?.inputChangeAdvanceAmounts?.reduce((acc, curr) => acc + curr, 0),
						inputChangeDescription: item?.inputChangeDescription || 'Initial Retirement', // Keep for API compatibility
						inputChangeEffectiveDate: utcConverter(dayjs(item?.inputChangeEffectiveDate)),
						inputChangeRetirementDate: utcConverter(dayjs(item?.inputChangeRetirementDate)),
						inputChangeRetirementTerm:
							Math.abs(dayjs(item?.inputChangeEffectiveDate)?.diff(dayjs(item?.inputChangeRetirementDate), 'month')) + 2,
					};
				}),
				// modifiedDateTime: utcConverter(dayjs()),
				// paymentModalityLabel: formData?.paymentModality?.toLowerCase() === 'start' ? 'Advance basis' : 'Acrual Basis',
				// endOfFinancialYear: utcConverter(formData?.endOfFinancialYear),
				// lastModifiedDate: utcConverter(dayjs()),
				// grossRentListSet: formData?.grossRentListSet,
				// advanceAmountListSet: formData?.advanceAmountListSet,
				// advanceDuration: formData?.advanceAmounts?.filter((item) => item !== 0)?.length,
			};

			const payloadData = {
				calculateData,
				identityData,
				scheduledIndex: index + 1,
			};
			const convertJson = JSON.stringify(payloadData);
			const convertBase64 = btoa(convertJson);
			const formattedPayload = {
				data: convertBase64,
				processCode: state?.processCode,
				scriptName: 'lease-controller-schedule-findata2',
				payloadData: payloadData,
			};
			try {
				await getJournalEntryData(formattedPayload);
				setShowJournalEntryModal(true);
			} catch (error) {
				console.error('Error in handleEyeButton:', error);
			}
		} else {
			const effectiveChanges = form.getFieldValue('changes')?.filter((_, index) => index !== 0);
			calculateData = {
				advanceAmount: 0, // Default value for table calculations
				retirementTerm: formData?.changes?.[0]?.inputChangeRetirementTerm || formData?.retirementTerm,
				discountRate: formData?.changes?.[0]?.inputChangeDiscountRate || formData?.initialDiscountRate,
				// Keep these for API - derived from retirementStartDate
				startDay: String(formData?.retirementStartDate?.date()),
				startMonth: String(formData?.retirementStartDate?.month() + 1),
				startYear: String(formData?.retirementStartDate?.year()),
				escalation: 0, // Default value for table calculations
				paymentFrequency: 'Monthly', // Default value for table calculations
				paymentTime: 'Start', // Default value for table calculations
				advanceDuration: 0, // Default value for table calculations
				upfrontLeasePayment: 0, // Default value for table calculations
				initialDirectCost: 0, // Default value for table calculations
				securityDeposit: 0, // Default value for table calculations
				endOfFinancialYear: formData?.retirementStartDate, // Default value for table calculations
				advanceAmounts: [], // Default value for table calculations
				grossRents: [], // Default value for table calculations
				retirementCost: formData?.retirementCost,
				changes: effectiveChanges.map((item, index) => {
					if (index === effectiveChanges.length - 1) {
						return {
							...item,
							upfrontLeasePayment: 0, // Default value for table calculations
							initialDirectCost: 0, // Default value for table calculations
							securityDeposit: 0, // Default value for table calculations
							inputChangeDescription: item?.inputChangeDescription || 'Initial Retirement', // Keep for API compatibility
						};
					}
					return {
						...item,
						inputChangeDescription: item?.inputChangeDescription || 'Initial Retirement', // Keep for API compatibility
					};
				}),
				grossRent: 0, // Default value for table calculations
			};
			const { changes, ...rest } = formData;
			identityData = {
				...rest,
				// Keep these for API - derived from retirementStartDate
				startYear: formData?.retirementStartDate?.year(),
				startMonth: formData?.retirementStartDate?.month() + 1,
				startDate: formData?.retirementStartDate?.date(),
				inputChangeMonth: '1', // Default value for API
				changes: changes.map((item) => {
					return {
						...item,
						// inputChangeAdvance: item?.inputChangeAdvanceAmounts?.reduce((acc, curr) => acc + curr, 0),
						inputChangeDescription: item?.inputChangeDescription || 'Initial Retirement', // Keep for API compatibility
					};
				}),
			};
			const payloadData = {
				calculateData,
				identityData,
				scheduledIndex: index + 1,
			};
			const convertJson = JSON.stringify(payloadData);
			const convertBase64 = btoa(convertJson);
			const formattedPayload = {
				data: convertBase64,
				processCode: state?.processCode,
				scriptName: 'lease-controller-schedule-findata2',
				payloadData: payloadData,
			};
			try {
				await getJournalEntryData(formattedPayload);
				setShowJournalEntryModal(true);
			} catch (error) {
				console.error('Error in handleEyeButton:', error);
			}
		}
	};

	const handleActionRequiredButton = async () => {
		const payloaddata = {
			id: rowId,
		};
		const convertJson = JSON.stringify(payloaddata);
		const convertBase64 = btoa(convertJson);
		const formattedPayload = {
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'lease-controller-schedule-ready',
			payloadData: payloaddata,
		};

		try {
			await getActionRequiredData(formattedPayload);
			// Refresh the lease schedule data after action is completed
			if (typeof queryV3Loader === 'function') {
				await queryV3Loader(true);
			}
		} catch (error) {
			console.error('Error in handleActionRequiredButton:', error);
		}
	};

	const columnData = useMemo(
		() => [
			{
				id: 'date',
				width: '5%',
				align: 'center',
				accessor: 'date',
				cellAlign: 'center',
				Header: 'Date',
			},
			{
				id: 'month',
				width: '5%',
				align: 'center',
				accessor: 'month',
				cellAlign: 'center',
				Header: 'Month',
			},
			{
				id: 'discountFactor',
				width: '5%',
				align: 'center',
				accessor: 'discountFactor',
				cellAlign: 'center',
				Header: 'Discount Factor',
			},
			{
				id: 'rowAdjustment',
				width: '5%',
				align: 'center',
				accessor: 'rowAdjustment',
				cellAlign: 'center',
				Header: 'Adjustment',
			},
			{
				id: 'rowClosingAROLiability',
				width: '5%',
				align: 'center',
				accessor: 'rowClosingAROLiability',
				cellAlign: 'center',
				Header: 'Closing ARO Liability',
			},
			{
				id: 'rowCumilitiveAdjustment',
				width: '5%',
				align: 'center',
				accessor: 'rowCumilitiveAdjustment',
				cellAlign: 'center',
				Header: 'Cumulative Adjustment',
			},
			{
				id: 'rowCumilitiveDepreciation',
				width: '5%',
				align: 'center',
				accessor: 'rowCumilitiveDepreciation',
				cellAlign: 'center',
				Header: 'Cumulative Depreciation',
			},
			{
				id: 'rowDepreciation',
				width: '5%',
				align: 'center',
				accessor: 'rowDepreciation',
				cellAlign: 'center',
				Header: 'Depreciation',
			},
			{
				id: 'rowInterest',
				width: '5%',
				align: 'right',
				accessor: 'rowInterest',
				cellAlign: 'right',
				Header: 'Interest',
			},
			{
				id: 'rowOpeningAROLiability',
				width: '5%',
				align: 'right',
				accessor: 'rowOpeningAROLiability',
				cellAlign: 'right',
				Header: 'Opening ARO Liability',
			},
			// {
			// 	id: 'interestExp',
			// 	width: '5%',
			// 	align: 'right',
			// 	accessor: 'interestExp',
			// 	cellAlign: 'right',
			// 	Header: 'Interest Expense',
			// },
			// {
			// 	id: 'payment',
			// 	width: '5%',
			// 	align: 'right',
			// 	accessor: 'payment',
			// 	cellAlign: 'right',
			// 	Header: 'Payment',
			// },
			// {
			// 	id: 'closingLeaseLiability',
			// 	width: '5%',
			// 	align: 'right',
			// 	accessor: 'closingLeaseLiability',
			// 	cellAlign: 'right',
			// 	Header: 'Closing Lease Liability',
			// },
			// {
			// 	id: 'adjustment',
			// 	width: '5%',
			// 	align: 'right',
			// 	accessor: 'adjustment',
			// 	cellAlign: 'right',
			// 	Header: 'Adjustment',
			// },
			...(isActionColumnShowAllow
				? [
						{
							Header: 'Action',
							Cell: (cell) => {
								// Only show the Action Required button when needed
								if (cell?.row?.original?.processStatus?.toLowerCase() === 'returned') {
									return (
										<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
											<div style={{ textAlign: 'center' }}>
												<Tooltip title="Action Required">
													<Button
														type="text"
														icon={<Notification01Icon width={16} height={16} color="#B00020" />}
														onClick={(e) => {
															e.stopPropagation();
															setRowId(cell?.row?.original?._id);
															setActionRequiredConfirmModal(true);
														}}
													></Button>
												</Tooltip>
											</div>
										</Box>
									);
								}
								// Return null if no action is needed
								return null;
							},
							disableSortBy: 'true',
							align: 'center',
						},
					]
				: []),
		],
		[isActionColumnShowAllow]
	);

	const tableData = Array.isArray(leaseControlData)
		? leaseControlData?.map((item, index) => ({
				...item,
				date: dayjs(item.date).format('YYYY-MM-DD'),
				id: index,
				period: index + 1,
				grossRent: formatNumber(item.grossRent, 2),
				discountFactor: formatNumber(item.discountFactor, 4),
				rentExp: formatNumber(item.rentExp, 2),
				interestExp: formatNumber(item.interestExp, 2),
				openLeaseLiability: formatNumber(item.openLeaseLiability, 2),
				interest: formatNumber(item.interest, 2),
				payment: formatNumber(item.payment, 2),
				closingLeaseLiability: formatNumber(item.closingLeaseLiability, 2),
				adjustment: formatNumber(item.adjustment, 2),
				advanceAmount: formatNumber(item.advanceAmount, 2),
				netPay: formatNumber(item.netPay, 2),
				ibr: formatNumber(item.ibr, 2),
				retirementCost: formatNumber(item.retirementCost, 2),
			}))
		: [];

	const ModalData = {
		head: 'Returned Lease - Required Action',
	};

	const mappedRowIndexColorMapping = useMemo(() => {
		// Define the color mapping for different processStatus values
		const statusColorMap = {
			Pending: '#E6F0FF', // light blue
			Unprocessed: '#E6F0FF', // light blue
			Reversed: '#ffcccc', // light red
			Returned: '#FFFDE6', // light yellow
			Recorded: '#E6FFE6', // light green
			Processed: '#E6F0FF', // light blue
		};

		// Create a new mapping object
		let newMapping = {};

		// Loop through the leaseControlData to populate the mapping
		Array.isArray(leaseControlData) &&
			leaseControlData?.forEach((lease, index) => {
				if (lease.processStatus) {
					if (lease.processStatus.toLowerCase() === 'returned') {
						setIsActionColumnShowAllow(true);
					}
					newMapping[index] = {
						rowColor: statusColorMap[lease.processStatus] || '#FCFCFC',
					};
				}
			});

		return newMapping;
	}, [leaseControlData]);

	const rowIndexColorMapping = mappedRowIndexColorMapping;

	return (
		<>
			{Array.isArray(tableData) && tableData?.length !== 0 && (
				<DataTable
					xlsxFileName={`${retirementId}_date`}
					COLUMNS={columnData || []}
					DATA={tableData || []}
					firstColStrick={false}
					pagination={false}
					rowIndexColorMapping={rowIndexColorMapping}
					pageSize={tableData.length}
					onClickHandler={(row) => handleEyeButton(row)}
				/>
			)}

			{showJournalEntryModal && (
				<LeaseRecordViewModal
					showModal={showJournalEntryModal}
					setShowModal={setShowJournalEntryModal}
					checkResponseData={journalEntryData?.responseData || []}
					tableUpperLeftExtraInfo={tableUpperLeftExtraInfo}
					isLoading={isJournalEntryDataLoading}
				/>
			)}

			{actionRequiredConfirmModal && (
				<ConfirmModal
					showModal={actionRequiredConfirmModal}
					setShowModal={setActionRequiredConfirmModal}
					modalData={ModalData}
					handleSubmit={handleActionRequiredButton}
				/>
			)}
		</>
	);
};

export default LeaseTable;
